import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getCodes: async({ dispatch, commit }, businessId) => {
        await request({ method: 'get', url: 'referral-codes', params: { businessId }})
            .then(res => {
                if (res.data && res.data.referralCodes) {
                    commit('SET_CODES', res.data.referralCodes)
                }
            })
    },

    getReferrals: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: 'referrals',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                leaderId: params.leader && params.leader.id || null,
                businessId: params.business && params.business.id || null,
                referralCodeId: params.referralCode && params.referralCode.id || null,
                ...Object.select(params, ['fromDate', 'toDate', 'clientId', 'page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.referrals) {
                commit('SET_REFERRALS', res.data.referrals)
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
            commit('SET_LOAD', false)
        })
    }
}
